<template>
  <div :class="$style['pt-branch-company-form']">
    <pt-page-title :title="isEdit?'编辑分/子公司':'新建分/子公司'"></pt-page-title>
    <pt-sub-title title="分/子公司信息"></pt-sub-title>
    <table :class="$style['role-customer-basic-message']">
      <pt-form-list-item label="公司名称：" required>
        <wt-input v-model="formValue.fullName" v-validate="'required'" data-vv-as="公司名称" placeholder="请输入公司名称">
        </wt-input>
      </pt-form-list-item>
      <pt-form-list-item label="公司性质：" required>
        <el-radio-group v-model="formValue.type" data-vv-as="公司性质" v-validate="'required'">
          <el-radio v-for="(item,index) in companyLable" :key="index" :label="item.value">{{item.label}}</el-radio>
        </el-radio-group>
      </pt-form-list-item>
      <pt-form-list-item label="业务类型：" required>
        <el-checkbox-group v-model="formValue.businessType" data-vv-as="业务类型" v-validate="'required'" style="display:flex">
          <el-checkbox v-for="(item,index) in Business" :key="index" :label="item.value">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </pt-form-list-item>
      <pt-form-list-item label="简称：" required>
        <wt-input v-model="formValue.name" v-validate="'required'" data-vv-as="公司名称" placeholder="请输入简称"></wt-input>
      </pt-form-list-item>
      <pt-form-list-item label="地区：" required>
        <wt-selector :class="$style['org-select']" data-vv-as="地区" v-validate="'required'" :options="addressList" v-model="formValue.addresses" multiple
                     filterable allow-create default-first-option></wt-selector>
      </pt-form-list-item>
      <pt-form-list-item label="收款方名称：">
        <wt-input v-model="formValue.payeeName" placeholder="请输入收款方名称">
        </wt-input>
      </pt-form-list-item>
      <pt-form-list-item label="电话号码：">
        <wt-input v-model="formValue.telephone" placeholder="请输入电话号码">
        </wt-input>
      </pt-form-list-item>
      <pt-form-list-item label="条码号前缀：">
        <wt-input v-model="formValue.codePrefix" placeholder="请输入条码号前缀">
        </wt-input>
      </pt-form-list-item>
      <pt-form-list-item label="微信特约商户号：">
        <wt-input v-model="formValue.weChatMerchantCode" placeholder="请输入微信特约商户号"></wt-input>
      </pt-form-list-item>
    </table>
  </div>
</template>

<script>
import {
  companyLable
} from 'json/adult-sell-order'
import formMixins from 'mixins/form'
// 组件class前缀
const prefixCls = 'pt-branch-company-form'

export default {
  name: 'pt-branch-company-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    organizations: {
      type: Array,
      default: function () {
        return []
      }
    },
    BranchCompanyDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    rolesList: {
      type: Array,
      default: function () {
        return []
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    Business: {
      type: Array,
      default: function () {
        return []
      }
    },
    addressList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  watch: {
    BranchCompanyDetail: {
      handler: function (val) {
        this.formValue = val
        this.formValue.addresses = val.addresses ? val.addresses : []
        if (/BRANCH/.test(val.type)) {
          this.formValue.type = 'BRANCH'
        } else {
          this.formValue.type = 'AGENT'
        }
        this.formValue.businessType = this.formValue.businessType ? this.formValue.businessType : []
      }
    },
    'formValue.type' (val) {
      if (!this.isEdit) {
        if (val === 'AGENT') {
          this.formValue.businessType = []
        }
        if (val === 'BRANCH') {
          this.formValue.businessType = []
          this.Business.forEach(element => {
            this.formValue.businessType.push(element.value)
          })
        }
      }
    }
  },
  data () {
    return {
      formValue: {
        businessType: []
      },
      companyLable: companyLable
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .menu-permissions {
    // margin-bottom: 20px;
    line-height: 40px;
  }

  .pt-branch-company-form {
    table {
      padding: 0 20px;
    }
    :global{
      .el-checkbox{
        margin-right:0
      }
    }
  }
  .org-select{
    width: 100%
  }
  .role-customer-basic-message {
    max-width: 500px
  }

  .org-select {
    width: 100%
  }

  .edit-password-text {
    color: red;
    font-size: 12px
  }

</style>
